import {MuWidget} from "mu-widget/lib/MuWidget";
import {CommentsCL} from "./generated/CommentsCL";
import {Htmlarea} from "./Htmlarea";
import {Arrays, sleepPromise} from "./Utils";

export class UiComment extends MuWidget {
	public cl: CommentsCL = new CommentsCL();
	public loadId: number|null = null;
	public commentTypeId: number = 1;
	public id: number = 0;
	public isRoot : boolean = false;
	private editable: boolean = false;

	beforeIndex() {
		this.container.classList.add('comment-items');
		// this.muVisible(!this.isRoot, '.');
		this.muAppendContent(`
			<div class="comment-items__title grid-column-s2" mu-id="title">
				<span>
					<strong mu-bind="accountName" mu-id="accountName"></strong> 
					<em mu-bind="commentTypeName"></em>
				</span>
				<span>
					<strong mu-bind="dtAdd|dateTime"></strong>
					<a href="" mu-bind='id|prepend("#comment-"):href' title="Odkaz na tento komentář">#</a>
				</span>			
			</div>
			<div class="comment-items__content grid-column-s2" mu-bind="content:innerHTML" mu-id="content"></div>
			<div class="comment-items__editor grid-column-s2" mu-bind="" mu-widget="Htmlarea" mu-id="contentEditor"></div>
			<div>
				<div mu-widget="UiRadioList" mu-id="commentType"></div>
			</div>
			<div class="comment-items__buttons" mu-id="pButtons">
				<span mu-id="bAdd" class="btn-icon btn-icon-size-3 icon-before-add">Přidat</span>
				<span mu-id="bEdit" class="btn-icon btn-icon-size-3 icon-before-edit">Upravit</span>
				<span mu-id="bCreate" class="btn-icon btn-icon-size-3 icon-before-add">Vytvořit</span>
				<span mu-id="bSave" class="btn-icon btn-icon-size-3 icon-before-ok">Uložit</span>
				<span mu-id="bCancel" class="btn-icon btn-icon-size-3 icon-before-cancel">Storno</span>
			</div>
			<!-- <div class="create-buttons" mu-id="createButtons">
				<span class="icon-before-edit a" mu-id="bEdit" mu-bind="editable:@visible">Upravit</span>
				<strong mu-bind="newTypes:@visible">Přidat: </strong>
				<span mu-bind="newTypes:@foreach">
					<span mu-template="newItemBtn" mu-widget="UiCommentsNewItem" class="a icon-before-comment"></span>
				</span> 
			</div> -->
			<div class="comment-items__items grid-column-s2" mu-id="comments" mu-bind="comments:@foreach">
				<div mu-template="commentItem" mu-widget="UiComment"></div>
			</div>`);
	}

	mode: Mode = "root";

	afterIndex() {
		if (this.loadId) {
			this.reloadComments();
		}
		// this.setEditing(false);
		/* if (!(this.muParent instanceof UiComment))
			this.muVisible(false, '.'); */

		this.setMode("view");
	}

	protected muAfterBindData(data: any) {
		this.id = data.id;
		this.editable = data.editable;
		this.setMode("view");
	}
	setEditing() {}

	public reloadComments() {
		// @ts-ignore
		return this.loadComments(this.loadId);
	}

	public async loadComments(id: number) {
		// const editing : Record<number, string>
		this.loadId = id;
		// @ts-ignore
		const res = await this.cl.withMessage("Načítám komentáře", this.container).getCommentFor('ticket', id);
		const commentsByParent: Record<number, any> = {};
		const mapContentTypeCreate = (ids: number[]) => ids
			.filter(ctid => res.allowCreate.includes(ctid) || res.allowCreate.includes(null))
			.map((ctid: number) => res.commentTypes[ctid]);
		for(const comment of res.comments) {
			const pid = comment.parentId || 0;
			const node = commentsByParent[pid] || (commentsByParent[pid] = []);
			node.push(comment);
		}
		for(const comment of res.comments) {
			comment.commentTypeName = comment.commentType.name;
			comment.newTypes = mapContentTypeCreate(res.commentTypeByParent[comment.commentTypeId] || []);
			comment.accountName = comment.account.name;
			comment.comments = commentsByParent[comment.id] || [];
		}

		this.muBindData({
			comments: commentsByParent[0] || [],
			newTypes: mapContentTypeCreate(res.commentTypeByParent[0] || []),
		});

		this.bAdd_click(null);

		/* this.muVisible(true, '.');

		// drobné úpravy vzhledu
		/* this.muVisible(false, 'bEdit');
		const pel = this.ui.createButtons.parentElement;
		pel.removeChild(this.ui.createButtons);
		pel.appendChild(this.ui.createButtons);
		this.muVisible(false, 'info');
		this.isRoot = true; */

	}

	getRootComment(): UiComment
	{
		return this.isRoot ? this : (this.muParent as unknown as UiComment).getRootComment();
	}

	/* newSubItem(contentTypeId: any) {
		const wComment = this.muWidgetFromTemplate("commentItem", "comments") as unknown as UiComment;
		wComment.muBindData({
			id: null,
			accountName: "Přidat",
		});
		wComment.commentTypeId = contentTypeId;
		// wComment.setEditing();
	} */

	bAdd_click(ev: Event|null) {
		const wComment = this.muWidgetFromTemplate("commentItem", "comments") as unknown as UiComment;
		wComment.muBindData({
			id: null,
		});
		wComment.commentTypeId = 1;
		wComment.setMode("new");
		if (ev) {
			(async() => {
				await sleepPromise(10);
				(this.muNamedWidget.contentEditor as unknown as Htmlarea).focus();
			})();
		}
	}

	/* public setEditing(editing: boolean = true) {
		this.muVisible(editing, [
			'!content',
			'contentEditor',
			'cBSave',
			'!createButtons',
		]);
		if (editing) (this.muNamedWidget.contentEditor as unknown as Htmlarea).focus();
	} */

	public setMode(newMode: Mode) {
		this.muVisible(newMode === "new", ["bCreate"]);
		this.muVisible(["new", "edit"].includes(newMode), [ "bCancel", "contentEditor" ]);
		this.muVisible(newMode === "view", [ "bAdd", "content" ]);
		this.muVisible(newMode === "view" && (this.editable || false) && !this.isRoot, "bEdit");
		this.muVisible(newMode === "new", "bCreate");
		this.muVisible(newMode === "edit", "bSave");
		this.muVisible(!this.isRoot, "title");
		if (newMode === "new") this.ui.accountName.innerText = "Nový komentář";
		this.ui.bAdd.innerText = this.isRoot ? "Přidat komentář" : "Odpovědět";
	}

	bCancel_click() {
		this.setMode("view");
		if (!this.id) this.muRemoveSelf();
	}

	async bEdit_click() {
		const comment = await this.cl.getComment(this.id);
		if (comment) {
			(this.muNamedWidget.contentEditor as unknown as Htmlarea).muBindData(comment.content);
			this.setMode("edit");
		}
	}

	async bSave_click() {
		const content = (this.muNamedWidget.contentEditor as unknown as Htmlarea).muFetchData();
		const rootComment = this.getRootComment();
		const data = this.id
			? { content: content }
			: {
				content: content,
				ticketId: rootComment.loadId,
				commentTypeId: this.commentTypeId,
				parentId: (this.muParent as unknown as UiComment).id
			};
		// @ts-ignore
		await this.cl.withMessage("Ukládám komentář").saveComment(this.id, data);
		this.setMode("view");
		rootComment.reloadComments();
	}

	async bCreate_click() {
		const content = (this.muNamedWidget.contentEditor as unknown as Htmlarea).muFetchData();
		const rootComment = this.getRootComment();
		const data = this.id
			? { content: content }
			: {
				content: content,
				ticketId: rootComment.loadId,
				commentTypeId: this.commentTypeId,
				parentId: (this.muParent as unknown as UiComment).id
			};
		// @ts-ignore
		await this.cl.withMessage("Ukládám komentář").saveComment(null, data);
		this.setEditing(false);
		rootComment.reloadComments();
	}
}

type Mode = "edit"|"new"|"view"|"root";

export class UiCommentsNewItem extends MuWidget {
	private id: any;
	muParent: UiComments;
	muBindData(src: any) {
		this.container.innerText = src.name;
		this.id = src.id;
	}

	container_click() {
		this.muParent.newSubItem(this.id);
	}
}